/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_SuccessInputs */

const en_story_success = /** @type {(inputs: Story_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story shared! It will expire in 24 hours.`)
};

const es_story_success = /** @type {(inputs: Story_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Historia compartida! Expirará en 24 horas.`)
};

const fr_story_success = /** @type {(inputs: Story_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story partagée ! Elle expirera dans 24 heures.`)
};

const de_story_success = /** @type {(inputs: Story_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story geteilt! Sie wird in 24 Stunden ablaufen.`)
};

const id_story_success = /** @type {(inputs: Story_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerita dibagikan! Itu akan kedaluwarsa dalam 24 jam.`)
};

/** @type {(inputs: Story_SuccessInputs) => LocalizedString} */
const ja_story_success = en_story_success;

/** @type {(inputs: Story_SuccessInputs) => LocalizedString} */
const zh_story_success = en_story_success;

/** @type {(inputs: Story_SuccessInputs) => LocalizedString} */
const ar_story_success = en_story_success;

/** @type {(inputs: Story_SuccessInputs) => LocalizedString} */
const it_story_success = en_story_success;

/** @type {(inputs: Story_SuccessInputs) => LocalizedString} */
const ru_story_success = en_story_success;

/** @type {(inputs: Story_SuccessInputs) => LocalizedString} */
const pt_story_success = en_story_success;

/** @type {(inputs: Story_SuccessInputs) => LocalizedString} */
const ko_story_success = en_story_success;

/**
* | output |
* | --- |
* | "Story shared! It will expire in 24 hours." |
*
* @param {Story_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_success = /** @type {((inputs?: Story_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_success(inputs)
	if (locale === "es") return es_story_success(inputs)
	if (locale === "fr") return fr_story_success(inputs)
	if (locale === "de") return de_story_success(inputs)
	if (locale === "ja") return ja_story_success(inputs)
	if (locale === "zh") return zh_story_success(inputs)
	if (locale === "ar") return ar_story_success(inputs)
	if (locale === "id") return id_story_success(inputs)
	if (locale === "it") return it_story_success(inputs)
	if (locale === "ru") return ru_story_success(inputs)
	if (locale === "pt") return pt_story_success(inputs)
	return ko_story_success(inputs)
});